<template>
  <div class="my-upload">
    <spinner spinnerText="上传中。。。" v-model="loading"></spinner>
    <el-upload action="~" :http-request="httpRequest" :show-file-list="false">
      <slot></slot>
    </el-upload>
  </div>
</template>
<script>
export default {
  name: "my-upload",
  props: {
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    httpRequest(content) {
      this.loading = true
      const param = new FormData()
      if(content.file.size > 30*1024*1024){
        this.$Message.warning("附件大小不能超过30M");
        this.loading = false
        return false;
      }
      param.append('file', content.file)
      this.$store.dispatch("common/upload", param)
        .then(res => {
          this.loading = false
          this.$emit("on-success", res)
        })
        .catch(error => {
          this.loading = false
          this.$emit("on-error", error)
        });
    }
  }
}
</script>
<style lang="less" scoped>
  .my-upload {
  }
</style>
